module.exports = ".inline-form-field {\n  margin-right: 16px; }\n"